import { Box, Text } from "@chakra-ui/react";
import { BsFillHeartFill } from "react-icons/bs";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      marginTop="60px"
      padding="20px"
      display="flex"
      flexDir={{ sm: "column", md: "row", lg: "row" }}
      alignItems="center"
      gap="10px"
      justifyContent="center"
    >
      <span><BsFillHeartFill color="red" /></span>
      <Text>
        Designed and built by <b>Rohini Kushwaha</b>, {currentYear} All rights reserved.
      </Text>
      <span><BsFillHeartFill color="red" /></span>
    </Box>
  );
};
